module.exports = __webpack_public_path__ + "static/fonts/ionicons.24712f6.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/iview/src/styles/common/iconfont/fonts/ionicons.ttf?v=2.0.0
// module id = 500
// module chunks = 123